export const mapAddedPeriods = response => response.data.map(period => period.args[0]);

export const mapAddPeriod = ({ periodData = {}, periodId = '' }) => [JSON.stringify(periodData), periodId];
